var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { Config } from "../../Config";
// Sample class for handling networking calls needed in order for FaceTec to function correctly.
// In Your App, please use the networking constructs and protocols that meet your security requirements.
//
// Notes:
// - Adding additional logic to this code is not allowed.  Do not add any additional logic outside of what is demonstrated in this Sample.
// - Adding additional asynchronous calls to this code is not allowed.  Only make your own additional asynchronous calls once the FaceTec UI is closed.
// - Adding code that modifies any App UI (Yours or FaceTec's) is not allowed.  Only add code that modifies your own App UI once the FaceTec UI is closed.
var FaceTecTestingAPINetworkingRequest = /** @class */ (function () {
    function FaceTecTestingAPINetworkingRequest() {
        var _this = this;
        this.TESTING_API_ENDPOINT = "/process-request";
        this.requestTypeString = "POST";
        //
        // Step 1: Construct the payload.
        //
        // - The payload contains the Session Request Blob
        // - Please see the notes below about correctly handling externalDatabaseRefID for certain call types.
        //
        this.send = function (faceTecTestingAPIPayload, requestCallback) {
            //
            // Step 2: Set up the networking request.
            //
            // - This Sample App demonstrates making calls to the FaceTec Testing API by default.
            // - In Your App, please use the webservice endpoint you have set up that accepts networking requests from Your App.
            // - In Your Webservice, build an endpoint that takes incoming requests, and forwards them to FaceTec Server.
            // - This code should never call your server directly. It should contact middleware you have created that forwards requests to your server.
            //
            var _a;
            // Extraer parámetros de validación desde la URL para pasarlos al middleware
            var urlParams = new URLSearchParams(window.location.search);
            var expectedDocumentType = urlParams.get('expectedDocumentType');
            var country = urlParams.get('country');
            // Construir endpoint con query params para el middleware
            var fullEndpoint = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT + _this.TESTING_API_ENDPOINT;
            if (expectedDocumentType || country) {
                var queryParams = new URLSearchParams();
                if (expectedDocumentType)
                    queryParams.append('expectedDocumentType', expectedDocumentType);
                if (country)
                    queryParams.append('country', country);
                fullEndpoint += "?".concat(queryParams.toString());
            }
            console.log('🌐 [FaceTec API] Iniciando petición a:', fullEndpoint);
            console.log('📋 [FaceTec API] Parámetros de validación:', {
                expectedDocumentType: expectedDocumentType || 'No especificado',
                country: country || 'No especificado'
            });
            _this.request.open(_this.requestTypeString, fullEndpoint);
            _this.request.setRequestHeader("Content-Type", "application/json");
            // Developer Note: This is ONLY needed for calls to the FaceTec Testing API.
            // You should remove this when using Your App connected to Your Webservice + FaceTec Server
            _this.request.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
            // Developer Note: This is ONLY needed for calls to the FaceTec Testing API.
            // You should remove this when using Your App connected to Your Webservice + FaceTec Server
            _this.request.setRequestHeader("X-Testing-API-Header", FaceTecSDK.getTestingAPIHeader());
            //
            // Step 3: Make the API Call, and handle the response.
            //
            // - Unless there is a networking error, or an error in your webservice or infrastructure, the Response Blob is retrieved and passed back into processResponse.
            // - For error cases, abortOnCatastrophicError is called as this would indicate a networking issue on the User device or network, or an error in Your Webservice.
            //
            _this.request.onload = function () {
                switch (_this.request.status) {
                    //
                    // Step 4:  Get the Response Blob and call processResponse on the Session Request Callback.
                    //
                    // - Call a convenience function that either gets a valid Response Blob, or handles the error and returns null.
                    // - Checks for null, indicating an error was detected and handled.
                    //
                    case 200:
                        try {
                            console.log('✅ [FaceTec API] Respuesta exitosa recibida (Status 200)');
                            _this.processResponse(requestCallback.processResponse);
                        }
                        catch (e) {
                            // You may want to implement some sort of retry logic here
                            // This should never be called except when a hard server error occurs. For example the user loses network connectivity.
                            console.error('❌ [FaceTec API] Error al parsear respuesta:', e);
                            console.log("FaceTecTestingAPINetworkingRequest >> request.onload >> Failed to parse responseText: ".concat(e));
                            requestCallback.abortOnCatastrophicError();
                        }
                        break;
                    // Handle other network status codes here as appropriate
                    default:
                        // You may want to implement some sort of retry logic here
                        // This should never be called except when a hard server error occurs. For example the user loses network connectivity.
                        console.error("\u274C [FaceTec API] Error del servidor - Status: ".concat(_this.request.status));
                        console.log("FaceTecTestingAPINetworkingRequest >> request.onload >> Server Status: ".concat(_this.request.status));
                        requestCallback.abortOnCatastrophicError();
                        ;
                }
            };
            // On catastrophic error call the onCatastrophicNetworkError handler
            // This should never be called except when a hard server error occurs. For example the user loses network connectivity.
            // You may want to implement some sort of retry logic here
            _this.request.onerror = function (ev) {
                console.error('❌ [FaceTec API] Error catastrófico de red:', ev);
                console.log("FaceTecTestingAPINetworkingRequest >> request.onerror >> Catastrophic error: ".concat(ev));
                requestCallback.abortOnCatastrophicError();
            };
            // Developer Note: With the Sample Networking library in this Sample App,
            // this code demonstrates getting the networking request progress and making
            // the appropriate call in the FaceTec Device SDK to update the upload progress.
            // This is how the FaceTec Upload Progress Bar gets changed.
            _this.request.upload.onprogress = function (ev) {
                var progress = Math.round((ev.loaded / ev.total) * 100);
                console.log("\uD83D\uDCCA [FaceTec API] Progreso de upload: ".concat(progress, "% (").concat(ev.loaded, "/").concat(ev.total, " bytes)"));
                requestCallback.updateProgress(ev.loaded / ev.total);
            };
            // Inyectar sessionId del frontend como instanceId para correlacionar en backend
            var instanceId = window.__sessionId || '';
            var finalPayload = __assign(__assign({}, faceTecTestingAPIPayload), { instanceId: instanceId });
            console.log('📤 [FaceTec API] Enviando payload:', {
                hasExternalDatabaseRefID: !!faceTecTestingAPIPayload.externalDatabaseRefID,
                requestBlobLength: ((_a = faceTecTestingAPIPayload.requestBlob) === null || _a === void 0 ? void 0 : _a.length) || 0,
                instanceId: instanceId
            });
            _this.request.send(JSON.stringify(finalPayload));
        };
        this.processResponse = function (onResponseBlobReceived) {
            var parsedResponse = JSON.parse(_this.request.responseText);
            var responseBlob = parsedResponse.responseBlob;
            var responseKeys = Object.keys(parsedResponse);
            console.log('📥 [FaceTec API] Procesando respuesta:', {
                hasResponseBlob: !!responseBlob,
                responseBlobLength: (responseBlob === null || responseBlob === void 0 ? void 0 : responseBlob.length) || 0,
                hasResult: !!parsedResponse.result,
                hasValidation: !!parsedResponse.validation,
                hasAutentikarFormat: !!parsedResponse.autentikarFormat,
                responseKeys: responseKeys
            });
            if (parsedResponse.result) {
                console.log('📋 [FaceTec API] Result del middleware:', parsedResponse.result);
            }
            // Si la respuesta incluye validación, guardarla globalmente para el onComplete
            if (parsedResponse.validation) {
                console.log('🔍 [FaceTec API] Validación recibida:', parsedResponse.validation);
                window.faceTecValidationData = parsedResponse.validation;
            }
            // Si la respuesta incluye autentikarFormat, guardarlo globalmente para el onComplete
            if (parsedResponse.autentikarFormat) {
                console.log('📦 [FaceTec API] AutentikarFormat recibido:', parsedResponse.autentikarFormat);
                window.faceTecAutentikarFormat = parsedResponse.autentikarFormat;
            }
            // Reportar al backend de logs el resultado del middleware. Útil para correlacionar
            // con las capturas: si livenessProven=false, suele venir un retry interno del SDK.
            try {
                var enviarLog = window.enviarLog;
                if (typeof enviarLog === 'function' && parsedResponse.result) {
                    var r = parsedResponse.result || {};
                    enviarLog('sdk_middleware_result', {
                        level: 'info',
                        triggerFlow: window.__currentTriggerFlow || '',
                        responseBlobLength: (responseBlob === null || responseBlob === void 0 ? void 0 : responseBlob.length) || 0,
                        hasValidation: !!parsedResponse.validation,
                        hasAutentikarFormat: !!parsedResponse.autentikarFormat,
                        // Campos del middleware FaceTec (los que vimos en sesión exitosa):
                        //   livenessProven: bool
                        //   matchLevel: 0..15  (15 = match perfectísimo)
                        //   ageV2GroupEnumInt: 0..N
                        livenessProven: r.livenessProven,
                        matchLevel: r.matchLevel,
                        ageV2GroupEnumInt: r.ageV2GroupEnumInt
                    });
                }
            }
            catch (e) {
                console.warn('⚠️ [Log] No se pudo enviar sdk_middleware_result:', e);
            }
            onResponseBlobReceived(responseBlob);
        };
        // Create a new request object
        this.request = new XMLHttpRequest();
    }
    return FaceTecTestingAPINetworkingRequest;
}());
export { FaceTecTestingAPINetworkingRequest };
